import {
  ADD_SERVICE_HISTORY_API,
  DISCOVERED_ASSETS_API,
  EXPORT_ASSETS_API,
  GET_ASSET_DETAILS_API,
  IMPORT_ASSETS_API,
  IMPORT_DISCOVERED_ASSETS_API,
  SEARCH_ASSETS_API,
  UPDATE_ASSET_ADDITIONAL_DETAILS_API,
  UPDATE_SERVICE_HISTORY_API
} from '~/constants/APIs'
import {
  IAssetData,
  IAssetAdditionalDetailForm,
  IAssetSearchForm,
  IAssetSearchResponse,
  IServiceHistory,
  IDiscoveredAsset,
  IImportDiscoveredAssetsRequest
} from '~/models'
import axiosClient from './axiosClient'

export const assetApis = {
  searchAssets: (params: IAssetSearchForm | null) =>
    axiosClient.get(SEARCH_ASSETS_API, {
      params
    }) as unknown as IAssetSearchResponse,

  getAssetDetails: (serialNumber: string) =>
    axiosClient.get(GET_ASSET_DETAILS_API + serialNumber) as unknown as IAssetData,

  exportAssets: (data: IAssetSearchForm | null) =>
    axiosClient.get(EXPORT_ASSETS_API, { params: data, responseType: 'blob' }),

  importAssets: (data: File[]) => {
    const formData = new FormData()
    data.forEach(item => formData.append('formFiles', item))
    return axiosClient.post(IMPORT_ASSETS_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  getDiscoveredAssets: (deviceFormationId: number) =>
    axiosClient.get(DISCOVERED_ASSETS_API, {
      params: { deviceFormationId }
    }) as unknown as IDiscoveredAsset[],

  importDiscoveredAssets: (data: IImportDiscoveredAssetsRequest) =>
    axiosClient.post(IMPORT_DISCOVERED_ASSETS_API, data),

  addServiceHistory: (data: IServiceHistory) =>
    axiosClient.post(ADD_SERVICE_HISTORY_API, data),

  updateServiceHistory: (data: IServiceHistory) =>
    axiosClient.put(UPDATE_SERVICE_HISTORY_API + data.id, data),

  updateAssetAdditionalDetails: (data: IAssetAdditionalDetailForm) =>
    axiosClient.post(
      UPDATE_ASSET_ADDITIONAL_DETAILS_API + data.serialNumber + '/AdditionalDetails',
      data
    )
}
